import {GetExamsProviderLocationParams} from 'domain/usecases';
import {makeGetExamsProviderLocation} from 'main/factories/usecases/private/booking-flow/remote-exams-booking/get-exams-provider-location-factory';
import {formatExamUnit} from '../../utils/formatExamUnit';
import {parseExamUnits} from '../../utils/parseExamUnits';

export async function getExamUnits(params: GetExamsProviderLocationParams) {
	const units = await makeGetExamsProviderLocation().get(params);

	if (!units) {
		return {
			unidadesPorLocal: [],
			unidadesPorRaio: [],
		};
	}

	const parsedUnitsByLocality = parseExamUnits(units.unidadesPorLocal);
	const parsedUnitsByDistance = units?.unidadesPorRaio
		? parseExamUnits(units.unidadesPorRaio)
		: [];

	const formattedUnitsByLocality = formatExamUnit(parsedUnitsByLocality, 'name');
	const formattedUnitsByDistance = formatExamUnit(parsedUnitsByDistance, 'distance');

	const unitsFormatted = {
		unidadesPorLocal: formattedUnitsByLocality,
		unidadesPorRaio: formattedUnitsByDistance,
	};

	return unitsFormatted;
}
